import { useState } from 'react';

const STATS = [
  { value: '3,200+', label: '收录漫画' },
  { value: '200+', label: '每日更新（话）' },
  { value: '500万+', label: '累计漫迷' },
];

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-sm font-medium mb-5 animate-fade-in">
              热门漫画一站式平台
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3 animate-fade-in-up">
              香蕉漫画 — 韩漫日漫国漫推荐大全
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-5 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              发现你的下一部最爱漫画，从这里开始
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-6 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              香蕉漫画精心筛选全网热门韩漫、日漫与国漫资源，按照恋爱、奇幻、热血、悬疑、搞笑等风格细致分类，每日更新最新章节。无论你是资深漫迷还是刚入坑的新读者，都能在这里轻松找到心仪的作品，享受高清画质与流畅的下拉式阅读体验，开启属于你的免费全集漫画之旅。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                立即探索
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-secondary-300 text-foreground-700 rounded-full font-medium text-sm hover:bg-secondary-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看排行
                <i className="ri-bar-chart-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-[560px] animate-scale-in" style={{ animationDelay: '0.2s' }}>
            {!imgError ? (
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20cozy%20manga%20reading%20scene%20with%20warm%20ambient%20lighting%2C%20open%20comic%20book%20pages%20floating%20in%20soft%20golden%20glow%2C%20Japanese%20and%20Korean%20manga%20style%20decorative%20elements%2C%20bookshelf%20background%20with%20colorful%20manga%20volumes%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20dreamy%20atmospheric%20light%2C%20artistic%20composition%20with%20gentle%20bokeh%20effects%2C%20magical%20reading%20atmosphere&width=1120&height=840&seq=hero-manga-visual-01&orientation=landscape"
                  alt="香蕉漫画 - 韩漫日漫国漫推荐大全 主视觉"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3] flex items-center justify-center">
                <div className="text-center text-foreground-400">
                  <i className="ri-book-open-line text-5xl block mb-3"></i>
                  <span className="text-sm">香蕉漫画</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}